import { api } from './client'
import type {
  ClientUser,
  DataEnvelope,
  TradeMode,
  UpdateSettingsRequest,
} from './types'

export interface SettingsResponse {
  data: ClientUser
  trade_mode: TradeMode
}

/**
 * Profile settings — API_DOCUMENTATION §5.5.
 * Both `trade:full` and `trade:read` may PATCH; password target depends on mode.
 */
export const settingsApi = {
  update: (body: UpdateSettingsRequest) =>
    api.patch<SettingsResponse>('/client/settings', body),
}

export type { DataEnvelope }
